(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accueil-hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const carousel = document.getElementById('HeroCarousel');
    if (!carousel) return;

    const slides = carousel.querySelectorAll('.hero__slide');
    const total = slides.length;
    if (total === 0) return;

    let current = 0;
    let autoTimer;

    function setSlide(index) {
      current = ((index % total) + total) % total;
      const prev = ((current - 1) + total) % total;
      const next = (current + 1) % total;

      slides.forEach((s, i) => {
        if (i === current) s.setAttribute('data-state', 'active');
        else if (i === prev) s.setAttribute('data-state', 'prev');
        else if (i === next) s.setAttribute('data-state', 'next');
        else s.removeAttribute('data-state');
      });

    }

    function startAuto() {
      stopAuto();
      autoTimer = setInterval(() => setSlide(current + 1), 1000);
    }

    function stopAuto() {
      clearInterval(autoTimer);
    }

    /* Init */
    setSlide(0);
    startAuto();

    /* Pause on hover */
    carousel.addEventListener('mouseenter', stopAuto);
    carousel.addEventListener('mouseleave', startAuto);

    /* Touch swipe */
    let touchStartX = 0;
    carousel.addEventListener('touchstart', e => {
      touchStartX = e.touches[0].clientX;
      stopAuto();
    }, { passive: true });

    carousel.addEventListener('touchend', e => {
      const diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        setSlide(diff > 0 ? current + 1 : current - 1);
      }
      startAuto();
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  function setView(mode) {
    const grid = document.getElementById('ProductGridContainer');
    const btns = document.querySelectorAll('.view-toggle__btn');
    if (!grid) return;
    grid.classList.toggle('product-grid--list', mode === 'list');
    btns.forEach(b => b.classList.toggle('active', b.dataset.view === mode));
  }

  function addToCartQuick(btn, variantId) {
    btn.classList.add('is-adding');
    btn.querySelector('span').textContent = '...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
    .then(r => r.json())
    .then(() => {
      btn.querySelector('span').textContent = '✓ Ajouté';
      document.dispatchEvent(new CustomEvent('cart:updated'));
      if (typeof cartDrawer !== 'undefined') cartDrawer.open();
      setTimeout(() => { btn.classList.remove('is-adding'); btn.querySelector('span').textContent = 'Ajouter'; }, 1500);
    })
    .catch(() => {
      btn.querySelector('span').textContent = 'Erreur';
      setTimeout(() => { btn.classList.remove('is-adding'); btn.querySelector('span').textContent = 'Ajouter'; }, 1500);
    });
  }

  window.setView = setView;
  window.addToCartQuick = addToCartQuick;

  // Floating Search Logic
  document.addEventListener('DOMContentLoaded', () => {
    const floatBtn = document.getElementById('FloatingSearchBtn');
    const mainSearch = document.querySelector('.shop-search-centered');

    if (floatBtn && mainSearch) {
      window.addEventListener('scroll', () => {
        const searchRect = mainSearch.getBoundingClientRect();
        if (searchRect.bottom < 0) {
          floatBtn.classList.add('is-visible');
        } else {
          floatBtn.classList.remove('is-visible');
        }
      });

      floatBtn.addEventListener('click', () => {
        window.scrollTo({
          top: mainSearch.offsetTop - 150,
          behavior: 'smooth'
        });
        const input = mainSearch.querySelector('input[type="text"]');
        if (input) setTimeout(() => input.focus(), 800);
      });
    }
  });


  } catch(e) { console.error(e); }
})();
})();
